<template>
  <RevCard
    class="!bg-static-info-max-disabled w-4/5 max-w-fit self-end whitespace-pre-line px-16 py-12 shadow-none md:w-3/5"
  >
    <slot />
  </RevCard>
</template>

<script lang="ts" setup>
import { RevCard } from '@ds/components/Card'
</script>
